module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-500.e8ddece.woff";